module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp12_6000.273148b9.png";